import { PropsWithChildren } from 'react';

const ListInfo: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex flex-col gap-3">{children}</div>;
};

export default ListInfo;
